var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M287.6 460V274H350l9.5-72.6h-72V155c0-21 6-35.3 36-35.3H362V55c-6.6-1-29.5-3-56-3-55.4 0-93.3 33.8-93.3 96v53.4H150V274h62.7v186h75z","fill":"#1877f2"}));
}

Facebook.defaultProps = {"viewBox":"0 0 512 512","width":"512","height":"512"};

module.exports = Facebook;

Facebook.default = Facebook;
